import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, ImageUploadWithPreview } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import { IoIosClose } from 'react-icons/io';
import { fetchSetting } from 'src/redux/action/setting.action';
import { shallowEqual } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loader from 'src/components/loader';
import MapContainer from 'src/components/Map';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Full Name must be a least 3 character long')
    .required('Full is required'),
  // tempAddress: Yup.string()
  //   .min(3, 'Temp Address must be a least 3 character long')
  //   .required('TempAddress is required'),
  image: Yup.string(),
});

const BusinessInfoTab: React.FC<IProps> = () => {
  const { settingData, loading, error } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const [previewImage, setPreviewImage] = React.useState<any>(
    settingData?.businessInfo?.logo
  );
  const [isHidden, setIsHidden] = useState(false);
  const [removeImage, setRemoveImage] = useState(false);
  const onClick = () => {
    setIsHidden(!isHidden);
    setRemoveImage(!removeImage);
  };

  const location = useLocation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (settingData?.businessInfo?.length > 0) return;
    dispatch(fetchSetting() as any);
  }, [dispatch]);
  const [latitude, setLatitude] = useState<any>(
    settingData?.businessInfo?.address?.coordinates?.latitude
  );
  const [longitude, setLongitude] = useState<any>(
    settingData?.businessInfo?.address?.coordinates?.longitude
  );

  // const state: any = window.localStorage.getItem('businessInfo');
  // const businessData = JSON.parse(state);
  const initValues = {
    name:
      settingData?.businessInfo?.name || settingData?.businessData?.name || '',
    image: settingData && settingData ? settingData?.businessInfo?.logo : '',
    pan: settingData && settingData ? settingData?.businessInfo?.pan : '',
    area: settingData?.businessInfo
      ? settingData?.businessInfo?.address?.area
      : '',
    city: settingData?.businessInfo
      ? settingData?.businessInfo?.address?.city
      : '',
    latitude: settingData?.businessInfo
      ? settingData?.businessInfo?.address?.coordinates?.latitude
      : '',
    longitude: settingData?.businessInfo
      ? settingData?.businessInfo?.address?.coordinates?.longitude
      : '',
  };

  const handleSubmitBusiness = async (values: any, { resetForm }: any) => {
    const payload = {
      // ...values
      address: {
        city: values?.city,
        area: values?.area,
        coordinates: {
          latitude: latitude,
          longitude: longitude,
        },
      },
      pan: values?.pan ?? '',
      name: values?.name,
      logo: values?.image,
    };
    try {
      await Service.post('/businesses/info/update', payload);
      // localStorage.setItem('businessInfo', JSON.stringify(values));
      toastAlert('success', `Business ${values?.name} is successfully created`);
      dispatch(fetchSetting() as any);
      // resetForm();
      // setPreviewImage('');
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader className="settings" />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          validationSchema={FORM_VALIDATION}
          onSubmit={handleSubmitBusiness}
        >
          {({ isValid, isSubmitting, setFieldValue }) => (
            <Form>
              <div className="relative">
                <div className="z-90 mb-5">
                  {/* {typeof settingData?.businessInfo?.logo === 'string' &&
                    !isHidden && (
                      <div className='flex justify-center'>
                        <img
                          src={settingData?.businessInfo?.logo}
                          alt="company-logo"
                        />
                        {!settingData?.businessInfo?.logo ? (
                          ''
                        ) : (
                          <IoIosClose
                            className="absolute -top-3 -right-2 bg-primary rounded-full"
                            size={20}
                            color="#FFFFFF"
                            onClick={onClick}
                          />
                        )}
                      </div>
                    )} */}
                  {/* {typeof settingData?.businessInfo?.logo !== 'string' ||
                  isHidden ||
                  !settingData?.businessInfo?.logo ? ( */}
                  <ImageUploadWithPreview
                    label="Company Logo"
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                    setFieldValue={setFieldValue}
                  />
                  {/* ) : null} */}
                </div>
              </div>
              <TextField
                label={'Business Name'}
                name="name"
                defaultValue={
                  settingData ? settingData?.businessInfo?.name : ''
                }
              />
              <TextField label={'PAN'} name="pan" />
              {/* <TextField
                label={'Temp Address'}
                name="tempAddress"
                defaultValue={
                  settingData ? settingData?.businessInfo?.tempAddress : ''
                }
              /> */}
              <TextField label={'Area'} name="area" />
              <TextField label={'City'} name="city" />
              {/* <MapContainer
                address={settingData?.businessInfo}
                radius={0}
                latitude={latitude}
                setLatitude={setLatitude}
                longitude={longitude}
                setLongitude={setLongitude}
              /> */}
              <div className="flex items-center justify-end mt-6">
                <Button
                  text="save information"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default React.memo(BusinessInfoTab);
